import { atomWithStorage, createJSONStorage, unstable_withStorageValidator } from "jotai/utils";
import { LocaleType } from "@/model";

const isValidLocale = (v: unknown): v is LocaleType =>
    v === "ko" || v === "en";

const getDefaultLocale = (): LocaleType => {
    if (typeof navigator === "undefined") {
        return "ko";
    }
    const lang = navigator.language.toLowerCase();
    return lang.startsWith("ko") ? "ko" : "en";
};

const storage = unstable_withStorageValidator(isValidLocale)(
    createJSONStorage()
);

const localeAtom = atomWithStorage<LocaleType>(
    "conversation_maker_locale",
    getDefaultLocale(),
    storage,
    { getOnInit: true }
);

export default localeAtom;
